const GROK_API_KEY = process.env.REACT_APP_GROK_API_KEY;
const GROK_IMAGE_URL = 'https://api.x.ai/v1/images/generations';
const DEFAULT_GROK_MODEL = 'grok-2-image-1212';
const RATIO_MAP = {
  '1:1': '1:1',
  '16:9': '16:9',
  '9:16': '9:16',
};
const RATIO_HINTS = {
  '16:9': 'cinematic ultra-wide 16:9 composition',
  '9:16': 'vertical poster 9:16 composition',
};

const promptAlreadyHasRatio = (text = '') => /--ar\s*\d+\s*:\s*\d+/i.test(text);

const addRatioToPrompt = (prompt = '', ratioKey) => {
  if (!ratioKey || !RATIO_MAP[ratioKey]) return prompt || '';
  if (promptAlreadyHasRatio(prompt)) return prompt || '';
  const trimmed = (prompt || '').trim();
  const ratio = RATIO_MAP[ratioKey];
  const hint = RATIO_HINTS[ratioKey];
  const suffix = hint ? `${hint} --ar ${ratio}` : `--ar ${ratio}`;
  return `${trimmed} ${suffix}`.trim();
};

export const isGrokAvailable = () => Boolean(GROK_API_KEY);

export const generateImageWithGrok = async (
  prompt,
  { count = 1, responseFormat = 'url', model = DEFAULT_GROK_MODEL, ratioKey } = {}
) => {
  if (!GROK_API_KEY) {
    throw new Error('Clé API xAI (Grok) manquante. Ajoutez REACT_APP_GROK_API_KEY.');
  }

  try {
    const finalPrompt = addRatioToPrompt(prompt, ratioKey);
    console.log('[Grok] Génération image:', finalPrompt);
    const response = await fetch(GROK_IMAGE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${GROK_API_KEY}`,
      },
      body: JSON.stringify({
        model,
        prompt: finalPrompt,
        n: count,
        response_format: responseFormat,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const message = errorData.error?.message || errorData.message || `HTTP ${response.status}`;
      throw new Error(`Erreur Grok: ${message}`);
    }

    const data = await response.json();
    const first = data?.data?.[0];
    if (!first?.url) {
      throw new Error('Réponse Grok inattendue (URL manquante).');
    }

    return {
      url: first.url,
      revisedPrompt: first.revised_prompt || finalPrompt,
      created: data.created,
    };
  } catch (error) {
    console.error('❌ Erreur génération Grok:', error);
    throw error;
  }
};
